import mixin from '../../mixins/Mixin.js';
export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const wrapper = editor.DomComponents.getWrapper();
  var random = mixin.methods.makeId();
  var image;
  const holidaysApi = {
    url: 'https://jours-feries-france.antoine-augusti.fr/api',
  };
  domc.addType('clocks', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': 'clock',
          config: btoa(JSON.stringify(config)),
          tagName: 'div',
          selectable: true,
          random: random,
          resizable: {
            step: 0.2,
            minDim: 20,
            maxDim: 100,
            currentUnit: 1,
            autoHeight: true,
            tl: 1, // Top left
            tc: 0, // Top center
            tr: 1, // Top right
            cl: 0, // Center left
            cr: 0, // Center right
            bl: 1, // Bottom left
            bc: 0, // Bottom center
            br: 1, // Bottom right
          },
          traits: [
            {
              type: 'search',
              label: 'Localité',
              name: 'locality',
              changeProp: 1,
              defaults: 'Paris,France',
              //  attributes: { 'data-related-type': 'rss' },
            },
            {
              type: 'select',
              label: 'Source',
              name: 'source',
              options: [
                { value: 'analogic1', name: 'Analogique1' },
                { value: 'analogic2', name: 'Analogique2' },
                { value: 'numeric', name: 'Numérique' },
              ],
              changeProp: 1,
            },
            {
              type: 'select',
              label: 'Date',
              name: 'hasDate',
              options: [{ value: 'yes', name: 'Oui' }, { value: 'no', name: 'Non' }],
              changeProp: 1,
            },
            {
              type: 'color',
              label: 'Couleur horloge',
              name: 'clock_color',
              changeProp: 1,
              defaults: 'black',
            },
            {
              type: 'color',
              label: 'Couleur Texte',
              name: 'text_color',
              changeProp: 1,
              defaults: 'black',
            },
            {
              type: 'color',
              label: "couleurs d'arrière plans",
              name: 'background_color',
              changeProp: 1,
              defaults: 'black',
            },
          ],
          hasDate: 'yes',
          source: 'analogic1',
          locality: 'Paris',
          holidays: [],
          style: {
            width: '40%',
            height: '16.6%',
            'font-size': '2vw',
          },
          copyable: true,
          copied: false,
          saved: false,
          script: function() {
            var css_file = document.createElement('link');
            css_file.setAttribute('rel', 'stylesheet');
            css_file.setAttribute('type', 'text/css');
            css_file.setAttribute('href', '//s.bookcdn.com//css/cl/bw-cl-180x170r1.css');
            document.getElementsByTagName('head')[0].appendChild(css_file);
            function setWidgetData_424274807(data) {
              if (typeof data != 'undefined' && data.results.length > 0) {
                for (var i = 0; i < data.results.length; ++i) {
                  var objMainBlock = '';
                  var params = data.results[i];
                  objMainBlock = document.getElementById(
                    'tw_' + params.widget_type + '_' + params.widget_id,
                  );
                  if (objMainBlock !== null) objMainBlock.innerHTML = params.html_code;
                }
              }
            }
            const config = `{[ config ]}`;
            const conf = JSON.parse(atob(config));
            const id = this.id;

            function updateClock(hours, minutes, seconds) {
              var hourDegrees = hours * 30;
              var minuteDegrees = minutes * 6;
              var secondDegrees = seconds * 6;
              let hour = $(`#${id} .hour-hand`);
              let minute = $(`#${id} .minute-hand`);
              let second = $(`#${id} .second-hand`);
              if (hour) {
                hour.css({
                  transform: `rotate(${hourDegrees}deg)`,
                });
              }
              if (minute) {
                minute.css({
                  transform: `rotate(${minuteDegrees}deg)`,
                });
              }
              if (second) {
                second.css({
                  transform: `rotate(${secondDegrees}deg)`,
                });
              }
            }

            setClockWithCurrentTime();
            function setClockWithCurrentTime() {
              var date = new Date();
              var hours = ((date.getHours() + 11) % 12) + 1;
              var minutes = date.getMinutes();
              var seconds = date.getSeconds();
              setTimeout(() => {
                updateClock(hours, minutes, seconds);
              }, 100);
            }

            setInterval(setClockWithCurrentTime, 1000);
            function getDateTime() {
              var now = new Date();
              var hour = now.getHours();
              var minute = now.getMinutes();
              var second = now.getSeconds();
              if (hour.toString().length === 1) {
                hour = '0' + hour;
              }
              if (minute.toString().length === 1) {
                minute = '0' + minute;
              }
              if (second.toString().length === 1) {
                second = '0' + second;
              }
              var dateTime = hour + ':' + minute + ':' + second;
              return dateTime;
            }
            function getFullDate() {
              var now = new Date();
              var year = now.getFullYear();
              var months = [
                'january',
                'february',
                'march',
                'april',
                'may',
                'june',
                'july',
                'august',
                'september',
                'october',
                'november',
                'december',
              ];
              var month = months[now.getMonth()];
              var day = now.getDate();
              var fullDate = day + ' ' + conf.translate[month]; // + ' ' + year;
              return fullDate;
            }
            function getDay() {
              var now = new Date();
              var days = [
                'sunday',
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
              ];
              var day = days[now.getDay()];
              return conf.translate[day] + ' ';
            }
            function getHolidays() {
              const holidays =
                JSON.parse(localStorage.getItem('gjs-holidays-' + new Date().getFullYear())) || [];
              const holiday = holidays.find(
                h =>
                  Math.floor(
                    (new Date().getTime() - new Date(h.date).getTime()) / (1000 * 60 * 60 * 24),
                  ) === 0,
              );
              return holiday ? 'Fête du jour: ' + holiday.nom_jour_ferie : '';
            }
            const clock = document.getElementById(id);
            clock.className.replace('gjs-comp-selected', '');
            var c = clock.className;
            var allclock = document.querySelectorAll('.' + c);
            allclock.forEach(function(clock) {
              var timeEl = clock.querySelector('[data-js=clock-time]');
              var dayEl = clock.querySelector('[data-js=clock-day]');
              var fullDateEl = clock.querySelector('[data-js=clock-date]');
              var holidays = clock.querySelector('[data-js=clock-holidays]');
              var title = clock.querySelector('[data-js=clock-title]');
              // example usage: realtime clock
              if (timeEl) {
                timeEl.innerHTML = '<h3>' + getDateTime() + '</h3>';
                setInterval(function() {
                  timeEl.innerHTML = '<h3>' + getDateTime() + '</h3>';
                }, 1000);
              }
              if (dayEl) {
                dayEl.innerHTML = '<strong>' + getDay() + '</strong>';
              }
              if (fullDateEl) {
                fullDateEl.innerHTML = '<strong>' + getFullDate() + '</strong>';
              }
              if (title) {
                title.innerHTML = conf.translate.title_clock;
              }
              if (holidays) {
                holidays.innerHTML = getHolidays();
              }
            });
          },
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'clocks' };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        this.listenTo(this.model, 'change:hasDate', this.handleUpdateSrc);
        this.listenTo(this.model, 'change:source', this.handleUpdateSrc);
        this.listenTo(this.model, 'change:locality', this.handleUpdateLocality);
        this.listenTo(this.model, 'change:text_color', this.handleTextColor);
        this.listenTo(this.model, 'change:clock_color', this.handleClockColor);
        this.listenTo(this.model, 'change:background_color', this.handleBackgroundColor);
      },
      buildUrl() {
        return holidaysApi.url + '/' + this.getYear();
      },
      getYear() {
        var now = new Date();
        var year = now.getFullYear();
        return year;
      },
      handleUpdateSrc() {
        let cssComposer = editor.CssComposer;
        let classes = this.model.getClasses();
        let style = cssComposer.getClassRule(classes[0]);
        let newDim;
        let resizable = this.model.get('resizable');
        this.model.set('random', mixin.methods.makeId());
        if (this.model.get('source') === 'analogic1') {
          style = {
            width: '40%',
            height: '16.6%',
            'font-size': '2vw',
          };
          newDim = {
            minDim: 15,
          };
          this.getAnalogicClock1();
        } else if (this.model.get('source') === 'analogic2') {
          style = {
            width: '32%',
            height: '24%',
            'font-size': '1.6vw',
          };
          newDim = {
            minDim: 20,
          };
          this.getAnalogicClock2();
        } else {
          style = {
            width: '30%',
            height: '20%',
            'font-size': '1.45vw',
          };
          newDim = {
            minDim: 10,
          };
          this.getNumericClock();
        }
        this.model.set('resizable', Object.assign({}, resizable, newDim));
        this.handleTextColor(classes);
        this.handleBackgroundColor(classes);
        this.handleClockColor(classes);
        editor.select(wrapper);
        if (classes && classes[0] && style) {
          let oldStyle =
            cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
              ? cssComposer.getClassRule(classes[0]).attributes.style
              : {};
          let newStyle = Object.assign({}, oldStyle, style);
          cssComposer.setClassRule(classes[0], newStyle);
        }
        let tidesModel = editor
          .getComponents()
          .models.find(item => this.view && item.attributes.attributes.id === this.view.el.id);
        let localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(
          item => {
            if (this.view && item.attributes.id === this.view.el.id) {
              item = tidesModel;
            }
            return item;
          },
        );
        this.model.view.el.className.replace('gjs-comp-selected', '');
        localStorage.setItem('gjs-js', editor.getJs());
        localStorage.setItem('gjs-html', editor.getHtml());
        localStorage.setItem('gjs-components', JSON.stringify(localStorageComponents));
      },
      handleUpdateLocality() {
        let locality = this.model.get('locality').toLowerCase();
        if (locality.indexOf('paris') + locality.indexOf('france') > -2) {
          const holidays = localStorage.getItem('gjs-holidays-' + this.model.view.getYear());
          if (holidays) {
            this.model.set('holidays', JSON.parse(holidays));
          } else {
            var xhttp = new XMLHttpRequest();
            let self = this;
            xhttp.onreadystatechange = function() {
              if (this.readyState === 4 && this.status === 200) {
                var data = JSON.parse(this.response);
                localStorage.setItem(
                  'gjs-holidays-' + self.model.view.getYear(),
                  JSON.stringify(data),
                );
                self.model.set('holidays', data);
              }
            };
            xhttp.open('GET', self.buildUrl(), true);
            xhttp.send();
          }
        }
      },
      handleClockColor() {
        const color = this.model.get('clock_color');
        const id = this.el.id;

        let classes = [
          'clock-' + this.model.get('random'),
          'icon-clock-' + this.model.get('random'),
        ];
        if (this.model.get('source') === 'analogic1') {
          classes = ['clock-' + this.model.get('random')];
        } else if (this.model.get('source') === 'analogic2') {
          classes = ['icon-clock-' + this.model.get('random')];
        }

        let cssComposer = editor.CssComposer;
        if (!(color && id)) {
          return;
        }
        const iframe = document.querySelector('.gjs-frame').contentWindow;
        const el = iframe.document.querySelector(`#${id} .clock,  #${id} .icon-clock`);
        let style = {
          'background-color': color,
          'background-image': `radial-gradient(circle at center, #ffffff 0.3em, transparent 0.2em),
    radial-gradient(circle at center, ${color} 50%, transparent 50%, transparent 65%, ${color} 65%),
    linear-gradient(to right, transparent 49%, #ffffff 49%, #ffffff 51%, transparent 51%),
    linear-gradient(to bottom, transparent 49%, #ffffff 49%, #ffffff 51%, transparent 51%),
    linear-gradient(-30deg, transparent 49.8%, #ffffff 49.8%, #ffffff 50.2%, transparent 50.2%),
    linear-gradient(30deg, transparent 49.8%, #ffffff 49.8%, #ffffff 50.2%, transparent 50.2%),
    linear-gradient(60deg, transparent 49.8%, #ffffff 49.8%, #ffffff 50.2%, transparent 50.2%),
    linear-gradient(-60deg, transparent 49.8%, #ffffff 49.8%, #ffffff 50.2%, transparent 50.2%)`,
        };
        if (el) {
          el.style.backgroundColor = style['background-color'];
          el.style.backgroundImage = style['background-image'];
          if (classes && classes.length > 0 && style) {
            for (let i = 0; i < classes.length; i++) {
              let oldStyle =
                cssComposer.getClassRule(classes[i]) &&
                cssComposer.getClassRule(classes[i]).attributes
                  ? cssComposer.getClassRule(classes[i]).attributes.style
                  : {};
              let newStyle = Object.assign({}, oldStyle, style);
              // let newClass ='i-'+classes[i];
              // grapesjsEMP.editors[0].getSelected().removeClass(classes[i]);
              // grapesjsEMP.editors[0].getSelected().addClass(newClass);
              // cssComposer.setClassRule(newClass, newStyle);
              cssComposer.setClassRule(classes[i], newStyle);
            }
          }
        }
      },
      handleTextColor() {
        const color = this.model.get('text_color');
        const id = this.el.id;

        let classes = [
          'emp-clock-container-date-current-' + this.model.get('random'),
          'emp-clock-container-time-current-' + this.model.get('random'),
          'numeric-date-' + this.model.get('random'),
        ];

        if (this.model.get('source') === 'analogic1') {
          classes = ['emp-clock-container-date-current-' + this.model.get('random')];
        } else if (this.model.get('source') === 'analogic2') {
          classes = ['emp-clock-container-date-current-' + this.model.get('random')];
        } else {
          classes = [
            'emp-clock-container-time-current-' + this.model.get('random'),
            'numeric-date-' + this.model.get('random'),
          ];
        }

        let cssComposer = editor.CssComposer;
        if (!(color && id)) {
          return;
        }
        const iframe = document.querySelector('.gjs-frame').contentWindow;
        const el = iframe.document.querySelector(
          `#${id} .emp-clock-container-date-current, #${id} .emp-clock-container-time-current`,
        );
        const elDate = iframe.document.querySelector(`#${id} .numeric-date`);
        let style = {
          color: color,
        };
        if (el) {
          el.style.color = style.color;
        }
        if (elDate) {
          elDate.style.color = style.color;
        }

        if (el || elDate) {
          if (classes && classes.length > 0 && style) {
            for (let i = 0; i < classes.length; i++) {
              let oldStyle =
                cssComposer.getClassRule(classes[i]) &&
                cssComposer.getClassRule(classes[i]).attributes
                  ? cssComposer.getClassRule(classes[i]).attributes.style
                  : {};
              let newStyle = Object.assign({}, oldStyle, style);
              cssComposer.setClassRule(classes[i], newStyle);
            }
          }
        }
      },
      handleBackgroundColor() {
        const color = this.model.get('background_color');
        const id = this.el.id;

        let classes = [
          'emp-clock-container-' + this.model.get('random'),
          'icon-clock-' + this.model.get('random'),
        ];
        if (this.model.get('source') === 'analogic1') {
          classes = ['emp-clock-container-' + this.model.get('random')];
        } else if (this.model.get('source') === 'analogic2') {
          classes = ['emp-clock-container-' + this.model.get('random')];
        } else {
          classes = [
            'emp-clock-container-' + this.model.get('random'),
            'icon-clock-' + this.model.get('random'),
          ];
        }

        let cssComposer = editor.CssComposer;
        if (!(color && id)) {
          return;
        }
        const iframe = document.querySelector('.gjs-frame').contentWindow;
        const el = iframe.document.querySelector(`#${id} .emp-clock-container, #${id} .icon-clock`);
        let style = {
          'background-color': color,
        };
        if (el) {
          el.style.backgroundColor = style['background-color'];
          if (classes && classes.length > 0 && style) {
            for (let i = 0; i < classes.length; i++) {
              let oldStyle =
                cssComposer.getClassRule(classes[i]) &&
                cssComposer.getClassRule(classes[i]).attributes
                  ? cssComposer.getClassRule(classes[i]).attributes.style
                  : {};
              let newStyle = Object.assign({}, oldStyle, style);
              cssComposer.setClassRule(classes[i], newStyle);
            }
          }
        }
      },
      getFullDate() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        if (month < 10) {
          month = '0' + month;
        }
        var day = now.getDate();
        var fullDate = year + '-' + month + '-' + day;
        return fullDate;
      },
      getNumericClock() {
        const comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized

        const content = `
          <div id="clock-grapes" class="emp-clock-container-${this.model.get(
            'random',
          )} emp-clock-container ">
              <div id="digital-clock" class="emp-clock-container-content digital-clock">
                  <div data-js="clock-time" class="emp-clock-container-time-current-${this.model.get(
                    'random',
                  )}  emp-clock-container-time-current" >
                      <h3>--:--:--</h3>
                  </div>
                  <div class="numeric-date-${this.model.get('random')} numeric-date" ${
          this.model.get('hasDate') === 'yes' ? '' : 'hidden'
        }>
                    <span data-js="clock-day">Lundi</span>
                    <span data-js="clock-date">01 janvier</span>
                  </div>
              </div>
          </div>`;
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          // setTimeout(() => {
          this.model.set('components', content);
          //}, 1000);
        }
      },
      getAnalogicClock1() {
        const comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized
        const content = `
              <div id="clock-grapes" class="emp-clock-container-${this.model.get(
                'random',
              )} emp-clock-container">
                  <div class="emp-clock-container-content">
                      <div class="clock-${this.model.get('random')} clock">
                          <div id="hour" class=" hour-hand hour"></div>
                          <div id="min" class=" minute-hand min"></div>
                          <div id="sec" class=" second-hand sec"></div>
                      </div>
                      <div class="emp-clock-container-time-date">
                          <div class="emp-clock-container-date-current-${this.model.get(
                            'random',
                          )} emp-clock-container-date-current">
                              <div class="date-analog2" ${
                                this.model.get('hasDate') === 'yes' ? '' : 'hidden'
                              }>
                                  <span data-js="clock-day"><strong>Lundi</strong></span>
                                  <span data-js="clock-date" ><strong>01 janvier</strong></span>
                               </div>
                              <div data-js="clock-holidays" class="holiday"></div>
                          </div>
                      </div>
                  </div>
              </div>`;
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          this.model.set('components', content);
        }
      },
      getAnalogicClock2() {
        const comps = this.model.get('components');
        // Add a basic countdown template if it's not yet initialized

        const content = `
        <div id="clock-grapes" class="emp-clock-container-${this.model.get(
          'random',
        )} emp-clock-container ">
            <div class="emp-clock-container-content analog2">
                <div class=" icon-clock-${this.model.get('random')}   icon-large icon-clock ">
                    <div class="clock2">
                        <ol>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ol>
                        <div id="hour" class="hour-hand hour"></div>
                        <div id="min" class="minute-hand min"></div>
                        <div id="sec" class="second-hand sec"></div>
                    </div>
                </div>
                <div class="emp-clock2-container-time-date">
                    <div class="emp-clock-container-date-current-${this.model.get(
                      'random',
                    )} emp-clock-container-date-current">
                    <div class="date-analog2" ${
                      this.model.get('hasDate') === 'yes' ? '' : 'hidden'
                    }>
                        <span data-js="clock-day"><strong>Lundi</strong></span>
                        <span data-js="clock-date"><strong>01 janvier</strong></span>
                    </div>
                    <span data-js="clock-holidays" class="holiday" ${
                      this.getHoliday() ? '' : 'hidden'
                    }><strong>${this.getHoliday()}</strong></span>
                    </div>
                </div>
            </div>
        </div>`;
        if (comps.length === 0) {
          comps.reset();
          comps.add(content);
        } else {
          this.model.set('components', content);
        }
      },
      getHoliday() {
        let holidays = this.model.get('holidays') || [];
        const holiday = holidays.find(
          h =>
            Math.floor(
              (new Date().getTime() - new Date(h.date).getTime()) / (1000 * 60 * 60 * 24),
            ) === 0,
        );
        return holiday ? 'Fête du jour: ' + holiday.nom_jour_ferie : null;
      },
      render(...args) {
        setTimeout(() => {
          this.handleClockColor();
          this.handleTextColor();
          this.handleBackgroundColor();
          this.handleUpdateLocality();
        }, 100);
        if (!this.model.get('saved')) {
          this.model.set('random', mixin.methods.makeId());
        }
        defaultView.prototype.render.apply(this, args);
        this.updateClasses();
        if (this.el.getElementsByTagName('DIV').length === 0) {
          this.getAnalogicClock1();
        }
        if (this.model.get('copied')) {
          this.handleUpdateSrc();
        }
        this.updateScript();
        return this;
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/clock/components.js